export const VERIFIER_TYPE = {
  SHARED_SECRET: 'Shared Secret',
  PUBLIC_KEY: 'Public Key',
  JWKS_URL: 'JWKS',
}
